/* eslint-disable max-len */
import React from "react";

interface SVGRProps {
  title?: string;
  titleId?: string;
}

const IconFilter = ({
    title,
    titleId = "tm-icon-icon-filter",
    ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 15 17"
        aria-hidden={!title}
        height="1em"
        width="1em"
        role={title ? "img" : ""}
        aria-labelledby={titleId}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            fill="#777"
            fillRule="evenodd"
            d="M3.571 13.374c.843 0 1.55.584 1.737 1.369l9.335.001c.197 0 .357.16.357.357v.118c0 .198-.16.357-.357.357H5.308a1.786 1.786 0 01-3.473 0H.357A.357.357 0 010 15.22v-.118c0-.197.16-.357.357-.357l1.478-.001a1.786 1.786 0 011.736-1.369zm7.143-6.66c.843 0 1.55.584 1.737 1.37h2.192c.197 0 .357.16.357.357v.118c0 .197-.16.357-.357.357H12.45a1.786 1.786 0 01-3.474 0H.357A.357.357 0 010 8.56v-.118c0-.197.16-.357.357-.357h8.62a1.786 1.786 0 011.737-1.37zM5 .054c.843 0 1.55.584 1.737 1.37h7.906c.197 0 .357.16.357.357v.118c0 .197-.16.357-.357.357l-7.906.001a1.786 1.786 0 01-3.474 0L.357 2.256A.357.357 0 010 1.899V1.78c0-.198.16-.357.357-.357h2.906A1.786 1.786 0 015 .053z"
        />
    </svg>
);

export default IconFilter;
